import React from 'react';
import { Phone, Calendar, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const MobileStickyBar = () => {
  const { t } = useLanguage();

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 flex">
      <a
        href="tel:+919876543210"
        className="flex-1 py-3 flex flex-col items-center justify-center text-navy hover:bg-gray-50 transition-colors border-r"
      >
        <Phone size={20} className="mb-1 text-clinical" />
        <span className="text-[10px] font-medium uppercase tracking-wider">{t('nav.call')}</span>
      </a>
      <a
        href="https://wa.me/919876543210"
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 py-3 flex flex-col items-center justify-center text-navy hover:bg-gray-50 transition-colors border-r"
      >
        <MessageCircle size={20} className="mb-1 text-[#25D366]" />
        <span className="text-[10px] font-medium uppercase tracking-wider">{t('nav.whatsapp')}</span>
      </a>
      <Link
        to="/appointment"
        className="flex-1 py-3 flex flex-col items-center justify-center bg-clinical text-white hover:bg-navy transition-colors"
      >
        <Calendar size={20} className="mb-1" />
        <span className="text-[10px] font-medium uppercase tracking-wider">{t('nav.book')}</span>
      </Link>
    </div>
  );
};

export default MobileStickyBar;
